import { HyperLink } from './Hyperlink';
import { formatDate } from './constants';
export class Rows {
    constructor(grid) {
        this.checkSelects = {};
        this.selectedTracker = {};
        this.tbody = null;
        this.grid = grid;
        this._renderCheckSelectCell = this._renderCheckSelectCell.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.selectAll = this.selectAll.bind(this);
    }
    singleSelect(field, rowId) {
        let checkSelectArray = this.checkSelects[field];
        if (!checkSelectArray) {
            return;
        }
        checkSelectArray.forEach((checkSelect) => {
            if (checkSelect.dataset.field === field) {
                let id = checkSelect.dataset.rowId;
                let selected = (rowId === id);
                checkSelect.checked = selected;
            }
        });
    }
    clearChecks(field) {
        let checkSelectArray = this.checkSelects[field];
        if (!checkSelectArray) {
            return;
        }
        checkSelectArray.forEach((checkSelect) => {
            if (checkSelect.dataset.field === field) {
                checkSelect.checked = false;
                const colDef = this.grid.columns[field];
                let rowId = checkSelect.dataset.rowId;
                if (rowId) {
                    this.grid.rowSelectChanged(rowId, false, colDef);
                }
            }
        });
    }
    selectAll(field, checked) {
        let checkSelectArray = this.checkSelects[field];
        if (!checkSelectArray) {
            return;
        }
        checkSelectArray.forEach((checkSelect) => {
            if (checkSelect.dataset.field === field) {
                checkSelect.checked = checked;
                const colDef = this.grid.columns[field];
                let rowId = checkSelect.dataset.rowId;
                if (rowId) {
                    this.grid.rowSelectChanged(rowId, checked, colDef);
                }
            }
        });
    }
    isAllSelected(field) {
        return this.selectedTracker[field];
    }
    fullySelectedFields() {
        let result = [];
        let fieldList = Object.keys(this.selectedTracker);
        fieldList.forEach(field => {
            if (this.selectedTracker[field]) {
                result.push(field);
            }
        });
        return result;
    }
    render() {
        let tbody = document.createElement('tbody');
        this._renderBodyRows(this, tbody, this.grid.visibleData());
        this.tbody = tbody;
        return tbody;
    }
    reRender() {
        if (this.tbody) {
            this.tbody.innerHTML = '';
            this._renderBodyRows(this, this.tbody, this.grid.visibleData());
        }
    }
    _addClasses(elt, classList) {
        if (classList) {
            let classes = classList.split(' ');
            classes.forEach(cls => {
                elt.classList.add(cls);
            });
        }
    }
    _renderBodyRows(self, tbody, data) {
        this.checkSelects = {};
        this.selectedTracker = {};
        let colDefs = this.grid.orderColumns();
        colDefs.forEach(colDef => {
            if (colDef.dataType == "checkSelect") {
                this.selectedTracker[colDef.field] = true;
            }
        });
        data.forEach((row, index) => {
            if (this.grid.pagination) {
                if (index < this.grid.pagination.firstVisibleElement || index >= this.grid.pagination.lastVisibleElement) {
                    return;
                }
            }
            let tr = document.createElement('tr');
            let selectedRowIds = this.grid.GetSelectedRowIds();
            colDefs.forEach(colDef => {
                if (colDef.hidden) {
                    if (colDef.isId) {
                        const td = document.createElement('td');
                        td.style.display = 'none';
                        if (colDef.tbCellClass) {
                            this._addClasses(td, colDef.tbCellClass);
                        }
                        const hiddenInput = document.createElement('input');
                        hiddenInput.type = 'hidden';
                        hiddenInput.setAttribute('data-field', colDef.field);
                        hiddenInput.value = row[colDef.field];
                        td.appendChild(hiddenInput);
                        tr.appendChild(td);
                    }
                    return;
                }
                switch (colDef.dataType) {
                    case "hyperlink":
                        tr.appendChild(self._renderHyperLinkCell(colDef.field, row));
                        break;
                    case "checkSelect":
                        tr.appendChild(self._renderCheckSelectCell(colDef.field, row, selectedRowIds));
                        break;
                    case "boolean":
                        tr.appendChild(self._renderBooleanCell(colDef.field, row, colDef));
                        break;
                    case "datetime":
                        tr.appendChild(self._renderDateTimeCell(colDef.field, row));
                        break;
                    case "date":
                        tr.appendChild(self._renderDateCell(colDef.field, row));
                        break;
                    default:
                        if (colDef.editable) {
                            tr.appendChild(self._renderEditableCell(colDef.field, row, colDef));
                        }
                        else {
                            tr.appendChild(self._renderTextCell(colDef.field, row));
                        }
                        break;
                }
            });
            tbody.appendChild(tr);
        });
    }
    _renderDateTimeCell(field, row) {
        const colDef = this.grid.columns[field];
        const td = document.createElement('td');
        const rawVal = row[field];
        if (colDef.tbCellClass) {
            this._addClasses(td, colDef.tbCellClass);
        }
        if (colDef.editable) {
            if (!this.grid.idColumn) {
                td.innerText = "Missing ID column";
                return td;
            }
            const id = row[this.grid.idColumn.field];
            const input = document.createElement('input');
            input.type = colDef.inputType || "datetime-local";
            input.dataset.rowId = id;
            input.dataset.field = field;
            if (rawVal) {
                const date = new Date(rawVal);
                input.value = date.toISOString().slice(0, 16);
            }
            input.addEventListener('change', this.inputChangeHandler);
            td.appendChild(input);
        }
        else {
            if (rawVal) {
                const date = new Date(rawVal);
                if (colDef.format) {
                    td.textContent = formatDate(date, colDef.format);
                }
                else {
                    td.textContent = date.toLocaleString(colDef.locale);
                }
            }
            else {
                td.textContent = '';
            }
        }
        return td;
    }
    _renderDateCell(field, row) {
        var _a;
        const colDef = this.grid.columns[field];
        const td = document.createElement('td');
        const rawVal = row[field];
        if (colDef.tbCellClass) {
            this._addClasses(td, colDef.tbCellClass);
        }
        if (colDef.editable) {
            const input = document.createElement('input');
            input.type = colDef.inputType || 'date';
            input.dataset.rowId = row[(_a = this.grid.idColumn) === null || _a === void 0 ? void 0 : _a.field];
            input.dataset.field = field;
            if (rawVal) {
                const date = new Date(rawVal);
                // Format as yyyy-MM-dd for HTML input[type="date"]
                const yyyy = date.getFullYear();
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');
                input.value = `${yyyy}-${mm}-${dd}`;
            }
            else {
                input.value = '';
            }
            input.addEventListener('change', this.inputChangeHandler);
            td.appendChild(input);
            return td;
        }
        if (rawVal === null || rawVal === undefined) {
            td.textContent = '';
        }
        else {
            const date = new Date(rawVal);
            if (colDef.format) {
                td.textContent = formatDate(date, colDef.format);
            }
            else {
                td.textContent = date.toLocaleDateString(colDef.locale);
            }
        }
        return td;
    }
    _renderCheckSelectCell(field, row, selectedRowIds) {
        let td = document.createElement('td');
        let checkSelect = document.createElement('input');
        checkSelect.type = 'checkbox';
        checkSelect.classList.add('dwc-datagrid-checkselect');
        checkSelect.classList.add('row-select');
        const colDef = this.grid.columns[field];
        if (colDef.tbCellClass) {
            this._addClasses(td, colDef.tbCellClass);
        }
        let idColDef = this.grid.idColumn;
        let rowId = (idColDef) ? row[idColDef.field] : null;
        checkSelect.dataset.rowId = rowId;
        checkSelect.dataset.field = field;
        let grid = this.grid;
        selectedRowIds.has(String(rowId)) ? checkSelect.checked = true : checkSelect.checked = false;
        if (!checkSelect.checked) {
            this.selectedTracker[field] = false;
        }
        checkSelect.addEventListener('change', (event) => {
            let checkSelectElement = event.currentTarget;
            grid.rowSelectChanged(checkSelectElement.dataset.rowId, checkSelectElement.checked, colDef);
        });
        let checkSelectArray = this.checkSelects[field];
        if (checkSelectArray) {
            checkSelectArray.push(checkSelect);
        }
        else {
            checkSelectArray = [];
            checkSelectArray.push(checkSelect);
            this.checkSelects[field] = checkSelectArray;
        }
        let div = document.createElement('div');
        div.classList.add('dwc-datagrid-checkselect-container');
        div.appendChild(checkSelect);
        td.appendChild(div);
        return td;
    }
    _renderHyperLinkCell(field, row) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const colDef = this.grid.columns[field];
        const td = document.createElement('td');
        if (colDef.tbCellClass) {
            this._addClasses(td, colDef.tbCellClass);
        }
        const cellValue = (_a = row[field]) !== null && _a !== void 0 ? _a : {}; // fallback to empty object
        let text = (_b = cellValue.text) !== null && _b !== void 0 ? _b : '';
        let url = (_c = cellValue.url) !== null && _c !== void 0 ? _c : '';
        let title = (_f = (_e = (_d = colDef.linkDefaults) === null || _d === void 0 ? void 0 : _d.title) !== null && _e !== void 0 ? _e : cellValue.title) !== null && _f !== void 0 ? _f : null;
        let target = (_j = (_h = (_g = colDef.linkDefaults) === null || _g === void 0 ? void 0 : _g.target) !== null && _h !== void 0 ? _h : cellValue.target) !== null && _j !== void 0 ? _j : null;
        const link = new HyperLink(text, url, title, target);
        td.appendChild(link.render());
        return td;
    }
    _renderTextCell(field, row) {
        var _a;
        const colDef = this.grid.columns[field];
        let td = document.createElement('td');
        if (colDef.tbCellClass) {
            this._addClasses(td, colDef.tbCellClass);
        }
        td.textContent = String((_a = row[field]) !== null && _a !== void 0 ? _a : '');
        return td;
    }
    _renderBooleanCell(field, row, colDef) {
        var _a;
        const td = document.createElement('td');
        const raw = row[field];
        const val = raw === true || raw === 'true';
        if (colDef.tbCellClass) {
            this._addClasses(td, colDef.tbCellClass);
        }
        if (colDef.editable) {
            const input = document.createElement('input');
            input.type = 'checkbox';
            input.checked = val;
            input.dataset.rowId = row[(_a = this.grid.idColumn) === null || _a === void 0 ? void 0 : _a.field];
            input.dataset.field = field;
            input.addEventListener('change', (e) => {
                const checkbox = e.currentTarget;
                this.grid.changeValue(input.dataset.rowId, field, checkbox.checked, checkbox);
                td.classList.add('dirty');
            });
            td.appendChild(input);
        }
        else {
            td.textContent = val ? 'True' : 'False';
        }
        return td;
    }
    _renderEditableCell(field, row, colDef) {
        let td = document.createElement('td');
        if (colDef.tbCellClass) {
            this._addClasses(td, colDef.tbCellClass);
        }
        if (!this.grid.idColumn) {
            td.innerText = "Missing ID column";
            return td;
        }
        let id = row[this.grid.idColumn.field];
        if (colDef.isId) {
            td.innerText = String(id);
            return td;
        }
        let input = document.createElement('input');
        let idColDef = this.grid.idColumn;
        if (colDef.inputType) {
            input.type = colDef.inputType;
        }
        if (colDef.pattern) {
            input.pattern = colDef.pattern;
        }
        input.value = row[field].toString();
        input.dataset.rowId = id;
        input.dataset.field = field;
        input.addEventListener('change', this.inputChangeHandler);
        td.appendChild(input);
        return td;
    }
    restoreValue(colDef, row, strId, input) {
        let val = row[colDef.field];
        if (val === null || val === undefined) {
            input.value = '';
        }
        else {
            input.value = String(val);
        }
    }
    inputChangeHandler(event) {
        let input = event.currentTarget;
        let rowId = input.dataset.rowId;
        let field = input.dataset.field;
        let value = input.value;
        let td = input.closest('td');
        if (td) {
            td.classList.add("dirty");
        }
        let tr = input.closest('tr');
        if (tr) {
            tr.classList.add("highlight-dirty-row");
        }
        this.grid.changeValue(rowId, field, value, input);
    }
}
